import React, { useEffect, useState } from "react";
import { VIDEO_COMMENTS } from "../utils/contants";
import { Link } from "react-router-dom";



const Comment = ({ data }) => {
  const { authorDisplayName, textOriginal, authorProfileImageUrl='https://yt3.googleusercontent.com/ytc/AIdro_mM0vhp5gCFnD_2QDd3WSb3KPtEoZD3xXUeu-nyb7cwMg=s160-c-k-c0x00ffffff-no-rj',authorChannelUrl  } = data;
  return (
    <div className="flex shadow-sm bg-gray-100 p-2 rounded-lg my-2">
      
        
                <img
                    className="w-12 h-12"
                    alt="user"
                    src={authorProfileImageUrl}
                    />
        
      <div className="px-3">
        <a className="font-bold" href={authorChannelUrl}> {authorDisplayName}</a>
        {/* <p ></p> */}
        <p>{textOriginal}</p>
      </div>
    </div>
  );
};

const CommentsList = ({ comments }) => {
  // Disclaimer: Don't use indexes as keys
//   console.log('comments ',comments);
  return comments.map((comment) => (
    <div key={comment?.id}>
      <Comment data={comment?.snippet?.topLevelComment?.snippet} />
    </div>
  ));
}; 

const OriginalComments = ({videoId}) => {

const [response, setResponse] = useState(null);
    
    useEffect(()=>{
        getComments();
    },[videoId]);

    const getComments = async ()=>{
        try{

        const data = await fetch(VIDEO_COMMENTS+videoId);
        console.log('data ',data);
        // if(data.status!=='200')
        //     setResponse('0');
        // else{
            const json = await data.json();
            console.log('data-json ',json);
            console.log('status ',json?.error?.code);
            if(json?.error?.code===403)
            setResponse('0');
            else
            setResponse(json);
        }
        catch(e){
            console.log('some error ',e);
        }
    }

  return (
    <div>
        { (response!=null && response!=='0') ?  (
            <div className="m-5 p-2">
                <h1 className="text-2xl font-bold">Comments: </h1>
                <CommentsList comments={response?.items} />
            </div>
        ) 
        :
        
        (  
            <div className="m-5 p-2">
                <h1 className="text-2xl font-bold">Comments: </h1>
                <p className="font-bold text-xl"> Comments Disabled or No comments to show. </p>
            </div>
        ) 
        }
            
    </div>
  );
};

export default OriginalComments;
